module.exports = __webpack_public_path__ + "img/chidiebere.42ec12dc.png";